import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useLocaleStore } from "@/store";
import { ref, watchEffect, computed } from "vue";
import zhCN from "element-plus/dist/locale/zh-cn.mjs";
import en from "element-plus/dist/locale/en.mjs";
import { useI18n } from "vue-i18n";
export default _defineComponent({
  __name: 'App',
  setup: function setup(__props) {
    var localeStore = useLocaleStore();
    var lang = ref('zh-CN');
    var locale = computed(function () {
      return lang.value === 'zh-CN' ? zhCN : en;
    });
    var i18n = useI18n();
    watchEffect(function () {
      var _document$querySelect;
      i18n.locale.value = lang.value = localeStore.value;
      (_document$querySelect = document.querySelector('html')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.setAttribute('lang', localeStore.value);
    });
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      var _component_el_config_provider = _resolveComponent("el-config-provider");
      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(locale)
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_router_view)];
        }),
        _: 1
      }, 8, ["locale"]);
    };
  }
});